import { getScreenSize } from './getScreenSize'
import { useViewportSizeWithCorrectInitialState } from './useViewportSizeWithCorrectInitialState'

export const useScreenSize = () => {
  const { width, height } = useViewportSizeWithCorrectInitialState()

  return getScreenSize(width, height)
}
